import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pickauto_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Clear token on 401 for admin endpoints
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err.config?.url?.includes("/admin/")) {
      localStorage.removeItem("pickauto_admin_token");
    }
    return Promise.reject(err);
  }
);

// Resolve upload URLs — backend returns /api/uploads/<file>
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Public
export const listVehicles = (params = {}) => api.get("/vehicles", { params }).then(r => r.data);
export const getVehicle = (id) => api.get(`/vehicles/${id}`).then(r => r.data);
export const listMakes = () => api.get("/makes").then(r => r.data);
export const submitTestDrive = (data) => api.post("/test-drive", data).then(r => r.data);
export const submitTradeIn = (data) => api.post("/trade-in", data).then(r => r.data);
export const submitContact = (data) => api.post("/contact", data).then(r => r.data);

// Admin
export const adminLogin = (email, password) => api.post("/admin/login", { email, password }).then(r => r.data);
export const adminMe = () => api.get("/admin/me").then(r => r.data);
export const adminListVehicles = () => api.get("/admin/vehicles").then(r => r.data);
export const adminCreateVehicle = (data) => api.post("/admin/vehicles", data).then(r => r.data);
export const adminUpdateVehicle = (id, data) => api.put(`/admin/vehicles/${id}`, data).then(r => r.data);
export const adminDeleteVehicle = (id) => api.delete(`/admin/vehicles/${id}`).then(r => r.data);
export const adminUploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};
